// NetworkMonitor.jsx

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setOnline, setOffline } from "../redux/slices/NetworkSlice";

export default function NetworkMonitor() {
  const dispatch = useDispatch();

  useEffect(() => {
    const online = () => dispatch(setOnline());
    const offline = () => dispatch(setOffline());

    window.addEventListener("online", online);
    window.addEventListener("offline", offline);

    navigator.onLine
      ? dispatch(setOnline())
      : dispatch(setOffline());

    return () => {
      window.removeEventListener("online", online);
      window.removeEventListener("offline", offline);
    };
  }, [dispatch]);

  return null;
}